<div class="page-panel">
    <div class="page-panel-header" [ngClass]="'backcolor-plangebiet-' + appStateService.navigationPlangebiet()">
        @if (showBackButton) {
            <button mat-icon-button color="primary" class="button-small-icon page-panel-header-back-button" (click)="button_back_clicked()" matTooltip="Zurück">
                <span color="secondary" class="material-symbols-outlined icon-24px icon-padding-left-6px">arrow_back_ios</span>
            </button>
        }
        
		<button mat-icon-button color="primary" class="button-small-icon-noborder"  (click)="iconMenuButton_clicked(undefined)" [matMenuTriggerFor]= "iconMenuButtons.length > 0 ? customMenuNav : null">
	       	@if (iconNameIonicon) {
      			  <span color="primary" class="page-panel-header-ionicon menu-icon icon ion-md-{{iconNameIonicon}} icon-32px"></span>
	        }
	 		@if (iconNameFontAwesome) {
            <span color="primary" class="page-panel-header-icon menu-icon material-symbols-outlined icon-32px">{{iconNameFontAwesome}}</span>
        }
		</button>
		<mat-menu #customMenuNav yPosition="below" [overlapTrigger]="false" class="custom-menu-width-nav">
			@for (item of iconMenuButtons; track item) {
				@if (item.divider) {
					<mat-divider></mat-divider>
				}
				@if (item.disabled) {
					<button mat-menu-item disabled>
						@if (item.icon) {
							<mat-icon>{{item.icon}}</mat-icon>
						}
						<span>{{item.label}}</span>
					</button>
				} @else {
					<button mat-menu-item (click)="iconMenuButton_clicked(item)"> 
						@if (item.icon && !item.Ionicon) {
							 <span color="primary" class="material-symbols-outlined iconMenuButton icon-24px">{{item.icon}}</span>
						}
						@if (item.Ionicon) {
							 <span color="primary" class="iconMenuButton icon ion-md-{{item.icon}} icon-24px"></span>
						}
						<span class="iconMenuButton">{{item.label}}</span>
					</button>    
				}
			}
			</mat-menu>

        <span class="page-panel-header-title font-title">{{pageTitle}}</span>
        <span class="flex-fill"></span>       
        @if (customButton1Title || customButton2Title || customButton3Title || customButton4Title || customMenuButton1Title) {
            <div class="flex flex-row flex-gap-8">
                @if (customButton1Title) {
                    <button id="customButton1" mat-stroked-button class="button-large" (click)="button_custom1_clicked()" matTooltip="{{customButton1Tooltip ?? customButton1Title}}" >{{customButton1Title}}</button>
                }
                @if (customButton2Title) {
                    <button id="customButton2" mat-stroked-button class="button-large" (click)="button_custom2_clicked()" matTooltip="{{customButton2Tooltip ?? customButton2Title}}">{{customButton2Title}}</button>
                }
                @if (customButton3Title) {
                    <button id="customButton3" mat-stroked-button class="button-large" (click)="button_custom3_clicked()" matTooltip="{{customButton3Tooltip ?? customButton3Title}}">{{customButton3Title}}</button>
                }
                @if (customButton4Title) {
                    <button id="customButton4" mat-stroked-button class="button-large" (click)="button_custom4_clicked()" matTooltip="{{customButton4Tooltip ?? customButton4Title}}">{{customButton4Title}}</button>
                }
                @if (customButton5Title) {
                    <button id="customButton5" mat-stroked-button class="button-large" (click)="button_custom5_clicked()" matTooltip="{{customButton5Tooltip ?? customButton5Title}}">{{customButton5Title}}</button>
                }
             
                @if (customMenuButton1Title) {
                    <button mat-stroked-button [matMenuTriggerFor]="customMenu" class="button-large" matTooltip="{{customMenuButton1Tooltip ?? customMenuButton1Title}}">{{customMenuButton1Title}}</button>
                    <mat-menu #customMenu="matMenu" yPosition="below" [overlapTrigger]="false" class="custom-menu-width">
                        @for (item of customMenuButton1Items; track item) {
                            @if (item.divider) {
                                <mat-divider></mat-divider>
                            }
                            @if (item.disabled) {
                                <button mat-menu-item disabled>
                                    @if (item.icon) {
                                        <mat-icon>{{item.icon}}</mat-icon>
                                    }
                                    <span>{{item.label}}</span>
                                </button>
                            } @else {
                                <button mat-menu-item (click)="button_custom_menu1_item_click(item)"> 
                                    @if (item.icon) {
                                        <mat-icon>{{item.icon}}</mat-icon>
                                    }
                                    <span>{{item.label}}</span>
                                </button>    
                            }
                        }
                      </mat-menu>
                }
            </div>
        }
        @if (showCheckedButton || showInfoButton || showEditButton || showDeleteButton || showHistoryButton || showDetailsButton || showSidepanelButton || showCloseButton) {
            <div class="flex flex-row flex-gap-8">
                @if (showCheckedButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_checked_clicked()" matTooltip="Alles bestätigen">
                        <span color="secondary" class="material-symbols-outlined icon-24px">done_all</span>
                    </button>
                }
                @if (showInfoButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_info_clicked()" matTooltip="Info">
                        <span color="secondary" class="material-symbols-outlined icon-24px">error</span>
                    </button>
                }
                @if (showEditButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_edit_clicked()" matTooltip="Editieren">
                        <span color="secondary" class="material-symbols-outlined icon-24px">edit_square</span>
                    </button>
                }
                @if (showDeleteButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_delete_clicked()" matTooltip="Löschen">
                        <span color="secondary" class="material-symbols-outlined icon-24px">delete</span>
                    </button>
                }
                @if (showHistoryButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_history_clicked()" matTooltip="Historie">
                        <span color="secondary" class="material-symbols-outlined icon-24px">device_reset</span>
                    </button>
                }
                @if (showDetailsButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_details_clicked()" matTooltip="Details">
                        <span color="secondary" class="material-symbols-outlined icon-24px">more_horiz</span>
                    </button>
                }
                @if (showSidepanelButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_sidepanel_clicked()" matTooltip="Info">
                        <span color="secondary" class="material-symbols-outlined icon-24px">dock_to_left</span>
                    </button>
                }
                @if (showCloseButton) {
                    <button mat-icon-button color="primary" class="button-small-icon" (click)="button_close_clicked()" matTooltip="Schließen">
                        <span color="secondary" class="material-symbols-outlined icon-24px">close</span>
                    </button>
                }
            </div>
        }
    </div>
    @if(showContent) {
        <div class="flex-fill flex-stretch-self page-panel-content page-panel-border" 
            [ngClass]="[showBackColor ? 'backcolor-background' : '']">
            <div class="flex flex-fill flex-stretch-self" [ngClass]="[resizeContent ? 'page-panel-content-overflow' : '']">
                <ng-content></ng-content>
            </div>
        </div>          
    }
</div>
